<template>
  <q-drawer
    :model-value="modelValue"
    class="bg-grey-4"
    side="right"
    bordered
    @update:model-value="value => $emit('update:model-value', value)"
  >
    <q-scroll-area class="fit">
      <q-list
        dense
      >
        <q-item
          class="bg-grey-8 q-mb-xs"
          style="padding: 0;"
        >
          <q-item-section class="full-width">
            <q-btn
              class="full-width"
              no-wrap
              square
              flat
              ripple
              @click="$emit('show-summary-page')"
            >
              <span class="full-width row justify-between text-white no-wrap">
                <q-icon name="none" />
                <span
                  class="text-uppercase ellipsis"
                  style="max-width: 220px;"
                >{{ title }}</span>
                <q-icon name="fullscreen" />
              </span>
            </q-btn>
          </q-item-section>
        </q-item>
        <kitchen-summary-item
          v-for="{ item_name, item_variation_name, modifiers, count } in summaryItems"
          :key="`${item_name}_${item_variation_name}_${modifiers.join('_')}`"
          style="margin-left: 2px; margin-right: 2px;"
          :item-name="item_name"
          :item-variation-name="item_variation_name"
          :modifiers="modifiers"
          :count="count"
        />
      </q-list>
    </q-scroll-area>
  </q-drawer>
</template>

<script>
import KitchenSummaryItem from 'src/modules/kds/components/KitchenSummaryItem'

export default {
  name: 'KitchenSummaryDrawer',
  components: {
    KitchenSummaryItem
  },
  configuration: ['currentSite'],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Kitchen Summary'
    },
    summaryItems: {
      type: Array,
      required: true
    }
  },
  emits: ['update:model-value', 'show-summary-page']
}
</script>
